import { Box, Divider, Hidden, Page, PageBlock } from 'braid-design-system';
import type { ReactNode } from 'react';

import Header from 'src/components/Header/Header';
import { SiteWideFooter } from 'src/components/SiteWideFooter';
import { VerifyEmailAlert } from 'src/components/VerifyEmailAlert';

interface PaymentContainerProps {
  width: 'small' | 'medium';
  children: ReactNode;
}

export const PaymentContainer = (props: PaymentContainerProps) => (
  <Page footer={<SiteWideFooter />} footerPosition="belowFold">
    <Header title="Sell your business" />

    <Hidden below="tablet">
      <Divider />
    </Hidden>

    <VerifyEmailAlert width={props.width} />

    <Box paddingTop="xlarge">
      <PageBlock width={props.width}>{props.children}</PageBlock>
    </Box>
  </Page>
);
